import { render } from "./BilancioSaldi.vue?vue&type=template&id=8feffabc&scoped=true"
import script from "./BilancioSaldi.vue?vue&type=script&lang=js"
export * from "./BilancioSaldi.vue?vue&type=script&lang=js"

import "./BilancioSaldi.vue?vue&type=style&index=0&id=8feffabc&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8feffabc"]])

export default __exports__